import React from 'react';

const CancellationPolicyDisplay = ({ policyType, freeCancellation }) => {
    // If freeCancellation is forced (e.g. from package) or policy is explicitly 'Free'
    if (freeCancellation || policyType === "Free") {
        return (
            <>
                <p className="mb-1" style={{ color: "#17a2b8", fontWeight: "bold" }}>Free Cancellation</p>
                <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    <strong>100%</strong> refund for all cancellations. No charges will be applied for any cancellation.
                </p>
            </>
        );
    }

    if (policyType === "Relaxed") {
        return (
            <>
                <p className="mb-1" style={{ color: "#28a745", fontWeight: "bold" }}>Relaxed Policy</p>
                <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    <strong>100%</strong> of the rental price if cancelled more than <strong>24 hours</strong> prior to commencement of the rental.<br />
                    <strong>50%</strong> of the rental price if cancelled within <strong>24 hours</strong> of commencement of the rental.
                </p>
            </>
        );
    }

    if (policyType === "Regulated") {
        return (
            <>
                <p className="mb-1" style={{ color: "#ffc107", fontWeight: "bold" }}>Regulated Policy</p>
                <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    <strong>100%</strong> of the rental price if cancelled more than <strong>7 days</strong> prior to commencement of the rental.<br />
                    <strong>75%</strong> of the rental price if cancelled less than <strong>7 days</strong> but more than <strong>48 hours</strong> prior to commencement of the rental.<br />
                    <strong>50%</strong> of the rental price if cancelled less than <strong>48 hours</strong> but more than <strong>24 hours</strong> prior to commencement of the rental.
                </p>
            </>
        );
    }

    if (policyType === "Restricted") {
        return (
            <>
                <p className="mb-1" style={{ color: "#dc3545", fontWeight: "bold" }}>Restricted Policy</p>
                <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    <strong>75%</strong> of the rental price if cancelled more than <strong>7 days</strong> prior to commencement of the rental.<br />
                    <strong>50%</strong> of the rental price if cancelled less than <strong>7 days</strong> but more than <strong>48 hours</strong> prior to commencement of the rental.<br />
                    <strong>25%</strong> of the rental price if cancelled less than <strong>48 hours</strong> but more than <strong>24 hours</strong> prior to commencement of the rental.
                </p>
            </>
        );
    }

    // Default BBR Policy
    return (
        <>
            <p className="mb-1" style={{ color: "#6c757d", fontWeight: "bold" }}>Standard BBR Policy</p>
            <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                <strong>Full refund</strong> if cancelled &gt; <strong>2 weeks</strong> prior.<br />
                <strong>20% deposit</strong> forfeited if cancelled <strong>2 weeks - 48h</strong> prior.<br />
                <strong>No refund</strong> if cancelled within <strong>48 hours</strong>.
            </p>
        </>
    );
};

export default CancellationPolicyDisplay;
